/** Whether two arrays hold the same elements, by identity, in the same order. */
export function sameElements<T>(a: readonly T[], b: readonly T[]): boolean {
    return (
        a.length === b.length &&
        a.every((element, index) => element === b[index])
    );
}
